import Button from "@/components/bricks/button/Button";
import RedoIcon from "../icons/RedoIcon";
import { MouseEvent, ReactNode } from "react";

export default function DefaultLoadingError(props: {
  label: ReactNode;
  refreshLabel?: string;
  onRefresh?: (event: MouseEvent<HTMLElement, MouseEvent>) => void;
}) {
  return (
    <div
      className="d-flex flex-row gap-4 align-items-center justify-content-between"
      style={{
        padding: "0.25rem 0",
      }}
    >
      <span className="text-muted">{props.label}</span>
      {props.refreshLabel && props.onRefresh && (
        <Button
          className="btn-primary btn--transparent"
          onClick={(event: MouseEvent<HTMLElement, MouseEvent>) => {
            if (props.onRefresh) {
              props.onRefresh(event);
            }
          }}
        >
          <RedoIcon />
          {props.refreshLabel}
        </Button>
      )}
    </div>
  );
}
